module.exports = __webpack_public_path__ + "img/pm-50.dce7742c.png";